/* ALLOW WHITELIST COUNTRIES */
function redirectHtml() {
  document.body.innerHTML = `
  <div class="redirection-box">
    <div class="redirection-logo">
      <img
        src="https://cdn.shopify.com/s/files/1/0755/3017/4762/files/hands_logo.png?v=1686285069" width="200px" height="auto">
    </div>
  </div>
  `;
}

function popupHtml(redirectUrl) {
  document.body.insertAdjacentHTML(
    "beforeend",
    `
    <style>
      #cr-overlay {
        position: fixed; inset: 0;
        background: rgba(0,0,0,0.6);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        z-index: 2147483647;
        display: flex; align-items: center; justify-content: center;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      }
      #cr-box {
        background: #fff;
        border-radius: 14px;
        padding: 36px 32px 32px;
        max-width: 400px;
        width: calc(100% - 40px);
        box-shadow: 0 20px 50px rgba(0,0,0,0.2);
        text-align: center;
      }
      #cr-box h2 {
        margin: 0 0 12px;
        font-size: 20px;
        font-weight: 700;
        color: #111;
      }
      #cr-box p {
        margin: 0 0 24px;
        font-size: 14px;
        color: #555;
        line-height: 1.6;
      }
      #cr-continue {
        display: block;
        width: 100%;
        padding: 13px;
        background: #111;
        color: #fff;
        font-size: 15px;
        font-weight: 600;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        box-sizing: border-box;
      }
      #cr-continue:hover { background: #333; }
    </style>
    <div id="cr-overlay">
      <div id="cr-box">
        <h2>You're browsing from a different region.</h2>
        <p>It looks like there's a regional website available for your location. Click <strong>Continue</strong> to visit the recommended website.</p>
        <button id="cr-continue">Continue</button>
      </div>
    </div>
  `,
  );
  document.body.style.overflow = "hidden";
  document.getElementById("cr-continue").addEventListener("click", function () {
    window.location.href = redirectUrl;
  });
}

// Function to detect if the user is a bot
function isBot() {
  const userAgent = navigator.userAgent.toLowerCase();
  const botSignatures = [
    "bot",
    "crawl",
    "spider", // Generic bot terms
    "googlebot",
    "google-inspectiontool",
    "googleother",
    "adsbot-google",
    "mediapartners-google", // Google bots
    "bingbot",
    "msnbot",
    "bingpreview", // Microsoft/Bing bots
    "yahoobot",
    "slurp", // Yahoo
    "baiduspider", // Baidu
    "duckduckbot", // DuckDuckGo
    "yandexbot",
    "yandeximages",
    "yandexmetrika", // Yandex
    "sogou", // Sogou
    "exabot", // Exalead
    "facebot",
    "facebookexternalhit", // Facebook
    "twitterbot", // Twitter
    "linkedinbot", // LinkedIn
    "pinterestbot", // Pinterest
    "slackbot",
    "slack-imgproxy", // Slack
    "discordbot", // Discord
    "telegrambot", // Telegram
    "applebot", // Apple
    "amazonbot",
    "awscloudbot", // Amazon
    "ia_archiver", // Alexa/Internet Archive
    "mj12bot",
    "majestic", // Majestic
    "ahrefsbot", // Ahrefs
    "semrushbot", // SEMrush
    "dotbot", // Moz
    "petalbot", // Huawei
    "seznambot", // Seznam
    "qwantify", // Qwant
    "coccocbot", // Coc Coc
    "yeti", // Naver
    "daum", // Daum
    "sentry", // Sentry monitoring
    "uptimerobot", // UptimeRobot
    "pingdom", // Pingdom
    "siteimprove", // Siteimprove
    "prerender", // Prerender.io
    "archivebot", // Archive.org
    "linkbot",
    "backlink", // Link checkers
    "screaming frog", // Screaming Frog SEO
    "deepcrawl", // DeepCrawl
    "webmeup", // WebMeUp
    "rogerbot", // Moz RogerBot
    "megaindex", // MegaIndex
    "blexbot", // BLEXBot
    "barkrowler", // Barkrowler
    "netcraft", // Netcraft
    "surdotlybot", // Surdotly
    "bytespider", // ByteDance
    "tineye", // TinEye
    "commoncrawl", // Common Crawl
    "heritrix", // Heritrix
    "sistrix", // SISTRIX
    "wotbox", // Wotbox
    "genieo", // Genieo
    "trendictionbot", // Trendiction
    "proximic", // Proximic
    "domaincrawler", // DomainCrawler
    "xenu", // Xenu Link Sleuth
    "scrapy", // Scrapy framework
    "python-requests",
    "python-urllib", // Python-based crawlers
    "curl",
    "wget", // Command-line tools
    "httpclient",
    "okhttp", // HTTP clients
    "headlesschrome", // Headless Chrome
    "phantomjs", // PhantomJS
    "playwright",
    "puppeteer", // Automation frameworks
  ]; // console.log("useragent", userAgent, "data", botSignatures.some(signature => userAgent.includes(signature)))
  return botSignatures.some((signature) => userAgent.includes(signature));
}

function allow_whitelist_countries() {
  // Whitelist countries
  const whitelist_singapore = [
    "SG",
    "KH",
    "CN",
    "ID",
    "MY",
    "PH",
    "KR",
    "TH",
    "MO",
    "VN",
    "TW",
    "HK",
    "Taiwan",
  ];

  const whitelist_uae = [
    "CY",
    "TR",
    "BH",
    "IR",
    "IQ",
    "IL",
    "JO",
    "KW",
    "LB",
    "OM",
    "PS",
    "QA",
    "SA",
    "AE",
    "YE",
    "EG",
  ]; // Checkouts page

  const checkoutsCountry = [
    "US",
    "CA",
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
    "CH",
    "TR",
    "GB",
    "RS",
    "AL",
    "LV",
    "LI",
    "LT",
    "LU",
    "MT",
    "TW",
  ];

  const middleEastCountry = [
    "TR",
    "AE",
    "SA",
    "IR",
    "IL",
    "JO",
    "QA",
    "LB",
    "IQ",
    "KW",
  ];

  function hideTax() {
    let tax = document.querySelector(".contact-form-tax");
    let totalTax = document.querySelector(".contact-form-totaltax");
    if (tax) tax.style.display = "none";
    if (totalTax) totalTax.style.display = "none";
  }

  function hideMiddleast() {
    let meCountryHideTax = document.querySelector(".subtotal-title");
    if (meCountryHideTax) meCountryHideTax.textContent = "Total (Ex Dubai)";
  } // Detecting the user's country

  function get_country_code(api_url) {
    fetch(api_url, { method: "GET" })
      .then((response) => response.json()) // Getting ip info as json
      .then((result) => {
        console.log("country code is ", result.country);
        const currentUrl = window.location.href;
        const urlPath = new URL(currentUrl).pathname; // Check if user is a bot

        if (isBot()) {
          console.log("bot"); // Log "bot" to console
        } else {
          // Only show popup once per browser session to avoid repeated prompts
          const popupShownKey = "hc_region_popup_shown";
          const alreadyShown = sessionStorage.getItem(popupShownKey); // Shopify appends ?shpxid=... when auto-redirecting across domains
          // Use this to detect first-time arrival after a cross-domain redirect

          const urlParams = new URLSearchParams(window.location.search);
          const wasShopifyRedirected = urlParams.has("shpxid");

          if (!alreadyShown) {
            if (!whitelist_singapore.includes(result.country)) {
              if (whitelist_uae.includes(result.country)) {
                // UAE user — show popup to go to .ae
                if (!window.location.href.includes(".ae")) {
                  sessionStorage.setItem(popupShownKey, "1");
                  popupHtml(`https://handscarpets.ae${urlPath}`);
                }
              } else {
                // All other countries (India, Europe, etc.) — show popup to go to .com
                // Fires if:
                //   a) User is on .ae or .asia (not yet on .com), OR
                //   b) Shopify just redirected them to .com via ?shpxid= (e.g. typed .ae from India)
                if (
                  !window.location.href.includes(".com") ||
                  wasShopifyRedirected
                ) {
                  sessionStorage.setItem(popupShownKey, "1");
                  popupHtml(`https://handscarpets.com${urlPath}`);
                }
              }
            } else if (whitelist_singapore.includes(result.country)) {
              // Asia user — show popup to go to .asia
              if (
                !window.location.href.includes(".asia") &&
                result.country !== "IN"
              ) {
                sessionStorage.setItem(popupShownKey, "1");
                popupHtml(`https://handscarpets.asia${urlPath}`);
              }
            }
          }
        } // Checkouts page logic (applies to both bots and non-bots)

        if (window.location.href.includes("/pages/checkouts")) {
          if (checkoutsCountry.includes(result.country)) {
            hideTax();
          }
          if (middleEastCountry.includes(result.country)) {
            hideMiddleast();
          }
          if (result.country == "IN") {
            let indSubtotal = document.querySelector(".subtotal-title");
            if (indSubtotal) indSubtotal.textContent = "Subtotal";
          }
        } // WhatsApp visibility (applies to both bots and non-bots)

        if (result.country == "IN") {
          let whatsapp = document.querySelector(".whatsapp-container");
          if (whatsapp) whatsapp.style.display = "block";
        }
      })
      .catch((error) => console.log("error", error));
  } // Getting country code from third party API

  get_country_code("https://get.geojs.io/v1/ip/country.json");
}

allow_whitelist_countries();
